export const INSTANCE_URL_LOCAL_STORAGE_KEY = 'intance_url';
